@if (columnModel.isEditable && !!control) {
    <arc-number-input
        [formControl]="control"
        [unit]="unitTranslated()"
        [isUnitTranslated]="true"
        [decimalPlaces]="castedColumnModel.decimalPlaces" />
} @else {
    <span [class.text-sm]="castedColumnModel.isCompact" [class.font-bold]="isBold(castedColumnModel.propertyName)">
        {{ getItemValue(castedColumnModel.propertyName) | arcNumber: castedColumnModel.decimalPlaces : '' : unitTranslated() }}
    </span>
}
